import { colors } from '@styleseat/brand';
import analytics from '../../../../../modules/analytics';
import { CARD_TYPES } from '../../Components/InsightCards/cards/InsightCardFactory';
import { InsightCardProps, InsightCardFactoryProps } from '../../Components/InsightCards/types';
import { postProviderInsightAction } from '../../../../../modules/Api';
import {
  INSIGHT_ACTION_PREFIX,
  INSIGHT_ACTIONS,
  MARKETING_TIPS_ACTIONS,
} from '../../../MarketingUtils/constants';
import stateManager from '../../../../../modules/user/stateManager';
import FeatureFlags from '../../../../../modules/FeatureFlags';
import { InsightModel } from '../types';
import { SITE_ROOT } from '../../../../../config';

export const SWITCH_NAME = 'provider_add_styleseat_to_instagram_com_840_060822';
export const ACTION_TYPE = 'addInstagramToStyleSeat'; // action type?
export const ACTION_PREFIX = `${INSIGHT_ACTION_PREFIX}add-instagram-to-styleseat`; // prefix?

export const ADD_STYLESEAT_TO_INSTAGRAM_ID = 'add-styleseat-to-instagram-profile-insight';
export const ADD_STYLESEAT_TO_INSTAGRAM_ANALYTICS_BASE_ID = 'pro_home_add_styleseat_account_to_instagram';

/**
 * parseCardData - parse data it into InsightCardProps
 * and return the results
 *
 * @param providerId
 * @returns : MarqueeCarProps
 */
const parseCardData = (
  provider,
  cardIndex,
  updateInsights,
  insightId,
): InsightCardProps => ({
  id: ADD_STYLESEAT_TO_INSTAGRAM_ID,
  headline: 'Add your StyleSeat account to Instagram',
  headlineColor: colors.blackInBlack,
  subheadColor: colors.slate,
  bodyText: [
    {
      text: 'Pros who add their StyleSeat account to Instagram make 10% more on average',
    },
  ],
  cta: 'copy your StyleSeat URL',
  // clickThroughData: {
  //   route: '',
  //   params: {},
  // },
  analyticsData: {
    event: `${ADD_STYLESEAT_TO_INSTAGRAM_ANALYTICS_BASE_ID}__click`,
    payload: {
      providerId: provider.id,
    },
  },
  firstViewTracking: () => analytics.track('pro_home_add_styleseat_account_to_instagram_view', { card_index: cardIndex }),
  onAction: async () => {
    postProviderInsightAction(provider.id, insightId, INSIGHT_ACTIONS.CTA_CLICKED);
    updateInsights({ type: MARKETING_TIPS_ACTIONS.cta, cardId: ADD_STYLESEAT_TO_INSTAGRAM_ID });
  },
  dismissParams: {
    analyticsDismissData: {
      event: `${ADD_STYLESEAT_TO_INSTAGRAM_ANALYTICS_BASE_ID}_grow_dismiss`,
      payload: {
        providerId: provider.id,
      },
    },
    onDismiss: () => {
      postProviderInsightAction(
        provider.id,
        insightId,
        INSIGHT_ACTIONS.DISMISS_CLICKED,
      );
      updateInsights({
        type: MARKETING_TIPS_ACTIONS.dismiss,
        cardId: ADD_STYLESEAT_TO_INSTAGRAM_ID,
      });
    },
    dismissText: 'No Thanks',
  },
  timeToComplete: '30 seconds',
  metadata: {
    copy_link: `${SITE_ROOT}/${provider.vanity_url ? provider.vanity_url : `/m/p/${provider.id}`}`,
  },
});

export const getInsights = async (): Promise<InsightModel> => {
  const enabled = await FeatureFlags.getFlagValue(SWITCH_NAME);

  try {
    const addStyleSeatToInstagramAction = await stateManager.getActionValue(`${ACTION_PREFIX}complete`);
    return addStyleSeatToInstagramAction || !enabled
      ? null
      : {
        insight_type: 'addStyleSeatToInstagram',
      };
  } catch (error) {
    return null;
  }
};

export const parseAddStyleSeatToInstagram = (
  provider, insight, updateInsights, user, metrics, cardIndex,
):
InsightCardFactoryProps => ({
  type: CARD_TYPES.inlineHeadlineWithCopyCta,
  cardProps: parseCardData(provider, insight.id, updateInsights, cardIndex),
});
